import React, { Component } from 'react';
import { connect } from 'react-redux';
import { array } from 'prop-types';
import { closeAlert, closeMessage } from '../../actions/alerts';
import CustomAlert from '../CustomAlert/CustomAlert';
import StickyBlock from '../../hoc/StickyBlock';

const propTypes = {
  alerts: array,
  messages: array,
};

const defaultProps = {
  alerts: [],
  messages: [],
};

class AlertNotification extends Component {
  getMessageParams = (params) => ({
    dismissable: true,
    alertType: params.type,
    message: params.message,
  });
  renderAlerts = (alerts) => {
    const alert = alerts[0];
    return (
      <CustomAlert
        params={alert}
        key={`alert_${alert.id}`}
        onClose={() => this.props.closeAlert(alert.id)}
      />
    );
  };

  renderMessages = (messages) => {
    const message = messages[0];
    return (
      <CustomAlert
        params={this.getMessageParams(message)}
        key={`message_${message.id}`}
        onClose={() => this.props.closeMessage(message.id)}
      />
    );
  };

  render() {
    const { alerts, messages } = this.props;
    const msgsLength = alerts.length + messages.length;

    if (msgsLength) {
      return (
        <StickyBlock dismissable={messages && messages.length}>
          {messages && messages.length ? (
            <div className="alert-notifications-wrapper">{this.renderMessages(messages)}</div>
          ) : null}
          {alerts && alerts.length ? (
            <div className="alert-notifications-wrapper">{this.renderAlerts(alerts)}</div>
          ) : null}
        </StickyBlock>
      );
    }

    return null;
  }
}

const mapStateToProps = (state) => ({
  alerts: state.alerts.alerts,
  messages: state.alerts.messages,
});

const mapDispatchToProps = (dispatch) => ({
  closeAlert: (id) => dispatch(closeAlert(id)),
  closeMessage: (id) => dispatch(closeMessage(id)),
});

AlertNotification.propTypes = propTypes;
AlertNotification.defaultProps = defaultProps;

export default connect(mapStateToProps, mapDispatchToProps)(AlertNotification);
